export interface DTOQueue {
  method: QueueMethods;
  data: unknown;
  messageId?: string;
  disableCache?: boolean;
}

export enum QueueMethods {
  COS_DOBNOW = "/lookup/co-dob-now",
  COS_BIS = "/lookup/co-bis",
  HELLO = "/queue/hello",
  PERMITS = "/lookup/permits",
  SBL = "/lookup/sbl",
}

export interface DTOQueueResponse {
  messageId?: string;
  method: string;
  hashkey: string;
  lastExecutedOn?: number;
  data?: unknown;
}
